export default __webpack_public_path__ + "static/media/phone.e28dde27.svg";